// extracted by mini-css-extract-plugin
module.exports = {"link":"_3k1ytl","icon":"g-wFPl","text":"_2snZx4"};